import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const UnderlineIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9 12.889a4.665 4.665 0 0 0 4.667-4.667V2h-1.944v6.222A2.72 2.72 0 0 1 9 10.945a2.72 2.72 0 0 1-2.723-2.723V2H4.334v6.222a4.665 4.665 0 0 0 4.667 4.667M14.445 14.444H3.555V16h10.89z"
      ></path>
    </svg>
  );
};

export default UnderlineIcon;
